import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var FileFetcherError = /*#__PURE__*/function (_BaseMediaClientError) {
  // Legacy Attribute. Should be removed

  function FileFetcherError(reason, metadata) {
    var _this;
    _classCallCheck(this, FileFetcherError);
    _this = _callSuper(this, FileFetcherError, [reason, metadata, undefined]);
    _this.id = metadata.id;
    return _this;
  }

  // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
  /** Will be deprecated. Use the properties `reason` and `metadata` instead */
  _inherits(FileFetcherError, _BaseMediaClientError);
  return _createClass(FileFetcherError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        _this$metadata = this.metadata,
        id = _this$metadata.id,
        collectionName = _this$metadata.collectionName,
        occurrenceKey = _this$metadata.occurrenceKey,
        traceContext = _this$metadata.traceContext;
      return _objectSpread({
        reason: reason,
        id: id,
        collectionName: collectionName,
        occurrenceKey: occurrenceKey
      }, traceContext && {
        metadata: {
          traceContext: traceContext
        }
      });
    }
  }]);
}(BaseMediaClientError);
export function isFileFetcherError(err) {
  return err instanceof FileFetcherError;
}